import { useState } from "react";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";

export default function ContactUs() {
    const [form, setForm] = useState({ name: "", email: "", message: "" });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // mailto opens email client
        window.location.href = `mailto:joseph@takamorirobot.com?subject=Inquiry from ${encodeURIComponent(
        form.name
        )}&body=${encodeURIComponent(form.message)}%0A%0AFrom: ${encodeURIComponent(
        form.email
        )}`;
    };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4">
        <Header />
        <div className="w-full max-w-2xl bg-white rounded-xl shadow-md p-8 sm:p-10 mt-[5rem]">
            <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">
                Contact Us
            </h1>
            <p className="text-gray-600 mb-8">
            Have a question or feedback? We'd love to hear from you.  
            You can reach us directly at{" "}
            <a
                href="mailto:joseph@takamorirobot.com"
                className="text-blue-600 underline hover:text-blue-800"
            >
                joseph@takamorirobot.com
            </a>
            .
            </p>

            {/* Contact Form */}
            <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                Name
                </label>
                <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:border-transparent"
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
                </label>
                <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:border-transparent"
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                Message
                </label>
                <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                rows="5"
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:border-transparent resize-none"
                />
            </div>

            <button
                type="submit"
                className="w-full bg-gray-900 text-white py-2.5 rounded-md font-medium hover:bg-gray-800 transition"
            >
                Send Message
            </button>
            </form>
        </div>
        <Footer />
    </div>
  );
}
